import {register} from './../exports/theme-sections';
import {mapStyle} from './../exports/mapStyles';
import {loadAPI, geocodeAddressPromise, createMap, destroyMap} from './../exports/mapLoader';

window.theme.allMaps = window.theme.allMaps || {};
var allMaps = window.theme.allMaps;

const mapSection = {
  async onLoad() {
    var mapContainer = this.container.querySelector('[data-map-container]');
    var key = this.container.getAttribute('data-api-key');
    if (key) {
      try {
        await loadAPI(key);
      } catch (error) {
        console.log(error);
      }
      var styleString = this.container.getAttribute('data-style') || '';
      var zoomString = this.container.getAttribute('data-zoom') || 14;
      var address = this.container.getAttribute('data-address');
      var center = await geocodeAddressPromise(address);
      var zoom = parseInt(zoomString, 10);
      var styles = mapStyle(styleString);
      var mapOptions = {
        zoom,
        styles,
        center,
        draggable: true,
        clickableIcons: false,
        scrollwheel: false,
        zoomControl: false,
        disableDefaultUI: true,
      };
      var map = await createMap(mapContainer, mapOptions);
      allMaps[this.id] = map;
    }
  },
  onUnload() {
    destroyMap(allMaps[this.id]);
  },
};

register('index-map', mapSection);
